module.exports = __webpack_public_path__ + "img/Zakinthos.40e5f586.png";